import colors from '@hydra/common/styles/colors';
import spacing from '@hydra/common/styles/spacing';
import breakpoints from '@hydra/common/styles/breakpoints';

const styleguide = {
  colors: colors,
  spacing: spacing,
  breakpoints: breakpoints
};

export default styleguide;
